import { newReconServiceAPI } from "./APIutils";
import { NEW_BASE_URL } from "../Constant";

export function fetchVehicleList({
  pageNo,
  pageSize = 10,
  searchString,
  cityFilter = [],
  operatorFilter = [],
  sortBy = {},
  contractType,
}) {
  const url = `${NEW_BASE_URL}/v1/contractsPage/allBusesContract`;
  return newReconServiceAPI(url, {
    addOnFilter: { cityIdArr: cityFilter, operatorIdArr: operatorFilter },
    pageNo,
    pageSize,
    sort: sortBy,
    search: searchString,
    status: contractType,
  });
}

export function fetchVehicleAllContracts({
  vehicleNo, pageNo, pageSize = 10, searchString = "", sortBy = {},
}) {
  const url = `${NEW_BASE_URL}/v1/contractsPage/allContractForVehicle`;
  return newReconServiceAPI(url, {
    addOnFilter: { busNumber: vehicleNo },
    pageNo,
    pageSize,
    sort: sortBy,
    search: searchString,
  });
}

export function terminateContract(contractId, busNumber) {
  const url = `${NEW_BASE_URL}/v1/contractsPage/closeContract`;
  return newReconServiceAPI(url, {
    contractId,
    busNumber,
  });
}

export function createContractService(contractDetails) {
  const url = `${NEW_BASE_URL}/v1/contractsPage/createContract`;
  return newReconServiceAPI(url, {
    contractDetails,
  });
}

export function editContractService(contractDetails) {
  const url = `${NEW_BASE_URL}/v1/contractsPage/editContract`;
  return newReconServiceAPI(url, {
    contractDetails,
  });
}

export function markCollectionHandledBy(collectionHandledByDetails) {
  const url = `${NEW_BASE_URL}/v1/contractsPage/markCollectionHandledBy`;
  // collectionHandledByDetails must have a 'borneBy' string and
  // 'vehicles' array with vehicle details
  return newReconServiceAPI(url, {
    ...collectionHandledByDetails,
  });
}

export function refreshUplift() {
  // TODO: remove this api completely
  // let url = `${NEW_BASE_URL}/v1/contractsPage/newContractBusUplift`
  // return newReconServiceAPI(url, {
  // });
}

export function updateBorneByService(params) {
  const {
    fromDate,
    toDate,
    busNumbers,
    borneBy,
    forEdit,
  } = params;
  const url = `${NEW_BASE_URL}/v1/contractsPage/verifyContractTerms`;
  return newReconServiceAPI(url, {
    fromDate,
    toDate,
    busNumbers,
    borneBy,
    forEdit,
  });
}

export function closeUpcomingContractsService(busNumbers) {
  const url = `${NEW_BASE_URL}/v1/contractsPage/closeUpcomingContracts`;
  return newReconServiceAPI(url, {
    busNumbers,
  });
}

export function closeActiveContractsService(busNumbers) {
  const url = `${NEW_BASE_URL}/v1/contractsPage/closeActiveContracts`;
  return newReconServiceAPI(url, {
    busNumbers,
  });
}
